import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=0b4a7eae&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4a7eae')) {
      api.createRecord('0b4a7eae', component.options)
    } else {
      api.reload('0b4a7eae', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=0b4a7eae&", function () {
      api.rerender('0b4a7eae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ek6Y9tadWIdo/JS/comp/ErrorMessage.vue"
export default component.exports